"use strict";

exports.__esModule = true;
exports.FilterFromList = void 0;
var _path2 = _interopRequireDefault(require("ramda/src/path"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Translator = require("../Translator");
var _SearchInput = require("../SearchInput");
var _DropdownCheckboxList = require("../DropdownCheckboxList");
var _Checkbox = require("../Checkbox");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FilterCheckboxWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FilterFromList__FilterCheckboxWrapper",
  componentId: "sc-17f6xkj-0"
})(["display:flex;flex-direction:row;justify-content:space-between;"]);
function setFilter(_ref, value) {
  var setFiltered = _ref.setFiltered,
    filtered = _ref.filtered,
    accessor = _ref.accessor;
  setFiltered(filtered.filter(function (filter) {
    return filter.id !== accessor;
  }).concat({
    id: accessor,
    value: value
  }));
}
var FilterFromList = exports.FilterFromList = function FilterFromList(props) {
  var _useState = (0, _react.useState)(""),
    searchText = _useState[0],
    setSearchText = _useState[1];
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var accessor = props.accessor,
    setFiltered = props.setFiltered,
    data = props.data,
    filtered = props.filtered,
    Cell = props.Cell,
    DownloadCellFormatter = props.DownloadCellFormatter,
    canSearch = props.canSearch;
  var columnFiltered = filtered.find(function (filterPoint) {
    return filterPoint.id === accessor;
  });
  var selectedValues = columnFiltered && Array.isArray(columnFiltered.value) ? new Set(columnFiltered.value) : new Set([]);
  var hasSearchMatched = function hasSearchMatched(str) {
    return !searchText.trim() ||
    // $FlowIgnore
    str.join(",").toLowerCase().includes(searchText.toLowerCase());
  };
  var items = Object.values(data.reduce(function (acc, row) {
    var value = (0, _path2["default"])(accessor.split("."), row);

    // Handle devices and types array
    if (Array.isArray(value)) {
      value.forEach(function (val) {
        var _DownloadCellFormatte;
        var valIdentifier = val && val.value ? val.value : val;
        var formattedStringValueList = DownloadCellFormatter ? DownloadCellFormatter((_DownloadCellFormatte = {}, _DownloadCellFormatte[accessor] = [val], _DownloadCellFormatte)) : [val];
        if (hasSearchMatched(formattedStringValueList)) {
          if (!acc[valIdentifier]) {
            acc[valIdentifier] = {
              count: 1,
              formattedValue: Cell ? Cell({
                value: [val]
              }) : val,
              rawValue: valIdentifier,
              isSelected: selectedValues.has(valIdentifier)
            };
          } else {
            // eslint-disable-next-line operator-assignment
            acc[valIdentifier].count = acc[valIdentifier].count + 1;
          }
        }
      });
    } else if (!acc[value]) {
      var _DownloadCellFormatte2;
      var formattedStringValueList = DownloadCellFormatter ? [DownloadCellFormatter((_DownloadCellFormatte2 = {}, _DownloadCellFormatte2[accessor] = [value], _DownloadCellFormatte2))] : [value];
      if (hasSearchMatched(formattedStringValueList)) {
        acc[value] = {
          count: 1,
          formattedValue: Cell ? Cell({
            value: value
          }) : value,
          rawValue: value,
          isSelected: selectedValues.has(value)
        };
      }
    } else {
      // eslint-disable-next-line operator-assignment
      acc[value].count = acc[value].count + 1;
    }
    return acc;
  }, {}));
  var isAllSelected = items.length === selectedValues.size;
  return /*#__PURE__*/_react["default"].createElement(_core.Menu, {
    key: accessor + "-filterMenu",
    style: {
      maxHeight: "250px",
      padding: "5px 0"
    }
  }, canSearch ? /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    shouldDismissPopover: false,
    text: /*#__PURE__*/_react["default"].createElement(_SearchInput.SearchInput, {
      onChange: setSearchText,
      value: searchText
    })
  }) : null, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    shouldDismissPopover: false,
    icon: /*#__PURE__*/_react["default"].createElement(_DropdownCheckboxList.DropdownCheckboxListContainer, null, /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
      checked: isAllSelected
    })),
    text: translate("DataTable.FilterCheckboxList.all", "(Select All)"),
    onClick: function onClick() {
      if (!isAllSelected) {
        setFilter({
          setFiltered: setFiltered,
          filtered: filtered,
          accessor: accessor
        }, items.map(function (element) {
          return element.rawValue;
        }));
      } else {
        setFilter({
          setFiltered: setFiltered,
          filtered: filtered,
          accessor: accessor
        }, []);
      }
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      maxHeight: "140px",
      overflow: "auto"
    }
  }, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      key: item.rawValue,
      icon: /*#__PURE__*/_react["default"].createElement(_DropdownCheckboxList.DropdownCheckboxListContainer, null, /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
        checked: item.isSelected
      })),
      shouldDismissPopover: false,
      text: /*#__PURE__*/_react["default"].createElement(FilterCheckboxWrapper, null, /*#__PURE__*/_react["default"].createElement("div", null, item.formattedValue)),
      onClick: function onClick() {
        if (item.isSelected) {
          selectedValues["delete"](item.rawValue);
        } else {
          selectedValues.add(item.rawValue);
        }
        setFilter({
          setFiltered: setFiltered,
          filtered: filtered,
          accessor: accessor
        }, Array.from(selectedValues));
      }
    });
  })));
};